// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3vWP1","errors":"Errors_errors__-H2x2"};